import React from "react";
import { ProductGrid } from "../_ResponsiveComponents";
import type { Product } from "../../hooks/products";

interface RecommendedProductsProps {
  products: Product[];
  loading?: boolean;
  title?: string;
}

const RecommendedProducts: React.FC<RecommendedProductsProps> = ({
  products,
  loading = false,
  title = "Recommended Products",
}) => {
  if (loading) {
    return (
      <div className="bg-section-card-bg rounded-lg shadow-sm p-6 mt-6 border border-section-border">
        <h3 className="text-lg font-semibold mb-4 text-section-text">{title}</h3>
        <div className="flex justify-center items-center py-8">
          <div className="text-sm text-section-muted">Loading recommendations...</div>
        </div>
      </div>
    );
  }

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <div className="bg-section-card-bg rounded-lg shadow-sm p-6 mt-6 h-auto border border-section-border">
      <h3 className="text-lg font-semibold mb-4 text-section-text">{title}</h3>

      <ProductGrid
        products={products.slice(0, 4)}
        viewMode="grid"
        loading={false}
        is_HScroll={true}
      />
    </div>
  );
};

export default RecommendedProducts;
